import React, { useContext } from 'react';
import styled from 'astroturf/react';
import pluralize from 'pluralize';
import { FeedContext } from 'js/social/contexts/feed';
import { FollowableUser } from 'js/social/shared/types';
import AvatarBase from 'js/social/shared/Avatar';
import { Button } from 'js/design_system/Button';
import { ButtonLink } from 'js/design_system/link/ButtonLink';
import { Body } from 'js/design_system/Body';
import { createUserFollowing } from 'js/social/api/user_following_api';
import _ToolTipContainer from "UserTooltip-ToolTipContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/UserTooltip.tsx?styleId=ToolTipContainer";
import _BodyBlack from "UserTooltip-BodyBlack.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/UserTooltip.tsx?styleId=BodyBlack";
import _FollowerBody from "UserTooltip-FollowerBody.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/UserTooltip.tsx?styleId=FollowerBody";
import _StyledFollowButton from "UserTooltip-StyledFollowButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/UserTooltip.tsx?styleId=StyledFollowButton";
import _StyledProfileButton from "UserTooltip-StyledProfileButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/UserTooltip.tsx?styleId=StyledProfileButton";
import _UserContentContainer from "UserTooltip-UserContentContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/UserTooltip.tsx?styleId=UserContentContainer";
import _Avatar from "UserTooltip-Avatar.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/UserTooltip.tsx?styleId=Avatar";


const ToolTipContainer = /*#__PURE__*/styled("div", null, {
  displayName: "ToolTipContainer",
  styles: _ToolTipContainer
});

const BodyBlack = /*#__PURE__*/styled(Body, null, {
  displayName: "BodyBlack",
  styles: _BodyBlack
});

const FollowerBody = /*#__PURE__*/styled(Body, null, {
  displayName: "FollowerBody",
  styles: _FollowerBody
});

const StyledFollowButton = /*#__PURE__*/styled(Button, null, {
  displayName: "StyledFollowButton",
  styles: _StyledFollowButton
});

const StyledProfileButton = /*#__PURE__*/styled(ButtonLink, null, {
  displayName: "StyledProfileButton",
  styles: _StyledProfileButton
});

const UserContentContainer = /*#__PURE__*/styled("div", null, {
  displayName: "UserContentContainer",
  styles: _UserContentContainer
});

const Avatar = /*#__PURE__*/styled(AvatarBase, null, {
  displayName: "Avatar",
  styles: _Avatar
});
interface Props {
  user: Partial<FollowableUser>;
}

export const UserTooltip: React.FC<Props> = ({ user }) => {
  const {
    userActions: { setUserFollowing },
  } = useContext(FeedContext);

  return (
    <ToolTipContainer>
      <UserContentContainer>
        <Avatar
          // @ts-ignore
          fullName={user.displayName}
          photoUrl={user.photo || ''}
          profileUrl={user.url}
        />
        <div>
          <BodyBlack size="md" bold>
            {user.displayName}
          </BodyBlack>
          {user.university && (
            <BodyBlack size="sm">{user.university?.displayName}</BodyBlack>
          )}
          {user.followers && user.followers > 0 && (
            <FollowerBody size="sm">
              {`${user.followers} ${pluralize('follower', user.followers)}`}
            </FollowerBody>
          )}
        </div>
      </UserContentContainer>
      {user.following === false ? ( // because it could be undefined, in which case we want the url
        <StyledFollowButton
          onClick={() => {
            if (user.id) {
              createUserFollowing(user.id, 'user_tag').then(() =>
                setUserFollowing(user.id || -1, true),
              );
            }
          }}
        >
          Follow
        </StyledFollowButton>
      ) : (
        <StyledProfileButton secondary href={user.url}>
          View Profile
        </StyledProfileButton>
      )}
    </ToolTipContainer>
  );
};

export default UserTooltip;
